import type { ShowSnackbarProps } from 'mobx/Infra/Infra.type'
import type { NextRouter } from 'next/router'
import type { Channel, Coupon, NonExternalCoupon, OrderType } from 'shared-types/Coupon'
import type { Menu } from 'types/Menu'
import type { StoreMetaData } from 'types/StoreContext'

export type StoreStatus = 'Active' | 'Closed'

export interface ExceptionDate {
	year: number
	month: number
	day: number
	hour: number
	minute: number
}

export default interface AvailabilityException {
	comment?: object
	start: ExceptionDate
	end: ExceptionDate
	available: boolean
}

export interface AvailabilitySegment {
	minuteOfWeek: number
	durationMins: number
}
export interface Availability {
	weekly: AvailabilitySegment[]
	exceptions?: AvailabilityException[]
}

export interface CouponToApply {
	coupon: NonExternalCoupon
	orderTypeToForce: OrderType | null
	ready: boolean
}

export enum CheckCouponOn {
	CHAIN = 'chain',
	STORE = 'store',
}

export interface StartCouponFlowProps {
	code: string
	orderTypeToForce: OrderType | null
	openModal?: boolean
	checkCouponOn?: CheckCouponOn
}

export interface CouponFlowDependencies {
	router: NextRouter | null
	getCoupon(code: string): Promise<Coupon | null>
	isLocalized(): boolean
	resetLocalization(): void
	isPageLegal(currentPath: string): boolean
	openLocalizationModal(couponToApply: CouponToApply): void
	isStoreClosed(): Promise<boolean>
	setCouponModal(coupon: Coupon | null): void
	showError(props: {
		message: string
		title?: string
		cancelText?: string
		okText?: string
		showCancelButton?: boolean
		okAction?: () => void
		cancelAction?: () => void
	}): void
	showConfirm(message: string, okAction: () => void, cancelAction?: () => void): void
	isChainClosed(): boolean
	isCouponForChannel(couponChannels: Channel[]): boolean
	isUserLoggedIn(): boolean
	getTranslatedTextByKey(path: string, fallback?: string): string
	assertCouponAvailable(coupon: Coupon, { date, channel, orderType }: { date: Date; channel: Channel; orderType: OrderType }): void
	getOrderType(): Promise<number | string | undefined>
	showSnackbar({ key, snackId, message, status, isAttachedToElement, duration }: ShowSnackbarProps): void
	getAndUpdateSession():
		| Promise<
				| {
						menuRes: Menu | null
						storeMetaData: StoreMetaData | null
						serverSession: unknown
						menuUrl: string
				  }
				| undefined
		  >
		| undefined
	removeDiscount(code: string): Promise<void>
}
